import { PayloadAction } from '@reduxjs/toolkit'
import { TReportingFilters } from '@unfoldrtech/portal-mic/dist/src/models/types'

const setAdGroupIds = (
  state: TReportingFilters,
  action: PayloadAction<{
    adGroupIds?: number[]
  }>
) => {
  state.adGroupIds = action.payload.adGroupIds
}

export default setAdGroupIds
